import type { FetchTenantsArgs } from '../../api/types/tenant.types';

import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export default function useTenants(
  filters: FetchTenantsArgs['filters'],
  options?: { enabled?: boolean },
) {
  const { queryFn, queryKey } = queryKeys.tenants.fetchTenants({ filters });
  return useQuery({
    enabled: options?.enabled ?? true,
    queryFn,
    queryKey,
  });
}
